import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { default as SurveyListContainer } from '../Project/ProjectListContainer';
import { default as SurveyCardPreviewContainer } from './SurveyCardPreviewContainer';
import { default as SurveyCardVoteContainer } from './SurveyCardVoteContainer';
import { RouteUrls } from '../../../configs/routeUrls';
import { ProjectType } from '../../../utils/enums';

export class Survey extends Component {
	render() {
		return (
			<div>
				<div>{this.props.children}</div>
				<Route
					exact
					path={RouteUrls.Survey.list.actual}
					render={(props) => (
						<SurveyListContainer
							{...props}
							type={ProjectType.Survey}
							listUrl={RouteUrls.Survey.list.actual}
							voteUrl={RouteUrls.Survey.vote}
							previewUrl={RouteUrls.Survey.preview}
						/>
					)}
				/>
				<Route
					exact
					path={RouteUrls.Survey.list.finished}
					render={(props) => (
						<SurveyListContainer
							{...props}
							type={ProjectType.Survey}
							listUrl={RouteUrls.Survey.list.actual}
							voteUrl={RouteUrls.Survey.vote}
							previewUrl={RouteUrls.Survey.preview}
						/>
					)}
				/>
				<Route path={`${RouteUrls.Survey.preview}/:id`} component={SurveyCardPreviewContainer} />
				<Route path={`${RouteUrls.Survey.vote}/:id`} component={SurveyCardVoteContainer} />
			</div>
		);
	}
}
